import { render, staticRenderFns } from "./dataView.vue?vue&type=template&id=0fd2a1d3&scoped=true"
import script from "./dataView.vue?vue&type=script&lang=js"
export * from "./dataView.vue?vue&type=script&lang=js"
import style0 from "./dataView.vue?vue&type=style&index=0&id=0fd2a1d3&prod&scoped=true&lang=scss&media=print"
import style1 from "./dataView.vue?vue&type=style&index=1&id=0fd2a1d3&prod&lang=scss&scoped=true"
import style2 from "./dataView.vue?vue&type=style&index=2&id=0fd2a1d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd2a1d3",
  null
  
)

export default component.exports